
export default {
  name: 'TennisIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
